export default "__VITE_ASSET__DFc78pWD__"